import { BadRequestError } from '../BadRequestError.js';
import type { ErrorCode } from '../PoolbettingError.js';

type FileUploadErrorCode =
  | Extract<ErrorCode, 'CLIENT'>
  | 'CONTENT_INVALID'
  | 'CONTENT_INVALID_HEADER'
  | 'CONTENT_BET_AMOUNT_MISSING'
  | 'CONTENT_DRAW_NUMBER_MISSING'
  | 'CONTENT_SYSTEM_SIZE_MISSING'
  | 'CONTENT_SYSTEM_UNSUPPORTED'
  | 'CONTENT_SYSTEM_MISSING'
  | 'CONTENT_SYSTEM_INCONSISTENT'
  | 'CONTENT_SYSTEM_SIZE_UNEXPECTED'
  | 'DRAW_CLOSED'
  | 'PRODUCT_NOT_SUPPORTED'
  | 'PRODUCT_MISMATCH'
  | 'AD_DRAW_MISMATCH';

export class BadRequestFileUploadError extends BadRequestError<FileUploadErrorCode> {
  constructor(message: string, options?: ErrorOptions, code: FileUploadErrorCode = 'CLIENT') {
    super(message, options, code);
    this.name = 'BadRequestFileUploadError';
  }
}
